import { useMemo } from "react";

interface FieldValidation {
  isValid: boolean;
  hasError: boolean;
  errorMessage: string;
}

export const useFieldValidation = (value: string, pattern: RegExp, errorMessage: string): FieldValidation => {
  return useMemo(() => {
    const isValid = pattern.test(value);
    const hasError = value.length > 0 && !isValid;
    return { isValid, hasError, errorMessage: hasError ? errorMessage : "" };
  }, [value, pattern, errorMessage]);
};
